<template>
  <div class="card">
    <div class="card-body">
      <template v-if="loading">
        <Spinner spinner-type="grow" min-height="300px" color="white" />
      </template>
      <template v-else-if="topContentUploaders.length">
        <div class="owl-carousel owl-theme top-content-carousel">
          <div
            v-for="(obj, i) in topContentUploaders"
            class="row align-items-center"
            :key="i"
          >
            <div class="col-sm-6">
              <img
                :src="asset_file_url(obj.user_profile_picture)"
                @error="image_load_error"
                class="img-fluid author"
                alt="author"
              />
            </div>
            <div class="col-sm-6 content-details">
              <div class="text-center">
                <h1 class="section-title">{{ __("Top Content Uploader") }}</h1>
                <h3 class="name">{{ locale_attr(obj, "user_name_{lang}") }}</h3>
                <h4 class="designation">
                  {{ locale_attr(obj, "designation_{lang}_name") }}
                </h4>
                <h4 class="institution">
                  {{ locale_attr(obj, "institution_{lang}_name") }}
                </h4>
                <ul class="listsss">
                  <li>
                    <span class="me-1">{{ __("Division") + __(":") }}</span>
                    {{ locale_attr(obj, "division_name_{lang}") }}
                  </li>
                  <li>
                    <span class="me-1">{{ __("District") + __(":") }}</span>
                    {{ locale_attr(obj, "district_name_{lang}") }}
                  </li>
                  <li>
                    <span class="me-1">{{ __("Upazila") + __(":") }}</span>
                    {{ locale_attr(obj, "upazila_name_{lang}") }}
                  </li>
                </ul>
                <button class="btn btn-primary goto">
                  {{ locale_attr(obj, "content_type_name_{lang}") }}
                  ({{ en_to_bn(obj.contents_count) }})
                </button>
              </div>
            </div>
          </div>
        </div>
      </template>
      <div
        v-else
        class="d-flex justify-content-center align-items-center"
        style="min-height: 300px"
      >
        <div>{{ __("No data found") }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Spinner from "../../components/Spinner";

export default {
  components: {
    Spinner,
  },

  data() {
    return {
      topContentUploaders: [],
      loading: false,
    };
  },

  mounted() {
    this.observe_visibility(this.$el, async () => {
      await this.getTopContentUploaders();
      $(".top-content-carousel").owlCarousel({
        loop: true,
        nav: false,
        items: 1,
        navText: [
          "<i class='fa fa-angle-left'></i>",
          "<i class='fa fa-angle-right'></i>",
        ],
      });
    });
  },

  methods: {
    async getTopContentUploaders() {
      this.loading = true;
      await axios
        .get("/dashboard/top-content-uploaders")
        .then(
          ({ data }) => (this.topContentUploaders = data.top_content_uploaders)
        )
        .catch(console.error);

      this.loading = false;
    },
  },
};
</script>
